import Vue from 'vue';
import NewMaterialApp from 'rrViewComponents/Inshape/Admin/Materials/AddMaterial/AddMaterialAppComponent/new-material-app';
import VueDataMapMixin from 'js/lib/vue/mixins/vue-data-map-mixin';
import VueSwMixin from 'js/lib/vue/mixins/vue-sw-mixin';
import { BootstrapVue } from 'bootstrap-vue';

export default function ($fragment) {
  const appDataKey = 'new-material-app';
  const autoloaderSelector = `[data-sw-${appDataKey}]`;

  $fragment.swFindWithSelf(autoloaderSelector).each((i, el) => {
    const vueAppOptions = {
      el: el,

      mixins: [VueDataMapMixin, VueSwMixin],

      components: {NewMaterialApp},

      data: () => ({
      }),

      created() {
        const appData = this.$sw.data[appDataKey];
        const dataAttrNames = Object.keys(this.$data);
        if (appData) {
          this.mapObjectPropertiesToVueData(appData, dataAttrNames);
        }
      }
    };
    Vue.use(BootstrapVue);
    new Vue(vueAppOptions);
  });
}
